<ng-template [ngIf]="user!=null">
    <app-navigation-bar></app-navigation-bar>
    <router-outlet></router-outlet>
</ng-template>
<ng-template [ngIf]="user==null">
    <app-login></app-login>
</ng-template>